 <section class="seccion-categorias">
   <div class="categoria-contenedor">
     <img src="assets/Encabezado/encabezado.jpg" alt="Imagen de categorías" class="categoria-imagen">
     <div class="categoria-contenido">
       <h1>Personaliza tu estilo y tus eventos con productos únicos</h1>
       <div class="botones-categoria">
         <button class="btn-categoria ropa" routerLink="/productos">Nuestros Productos</button>
         <button class="btn-categoria promocionales" routerLink="/articulospromocionales">Promocionales</button>

       </div>
     </div>
   </div>
 </section>